var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selectLanguageWrapper"},_vm._l((_vm.options),function(option){return _c('span',{key:option.value,staticClass:"cursor-pointer mr-2",class:{ 'strong': (_vm.selected && _vm.selected.value == option.value) },on:{"click":function($event){_vm.selected = option}}},[_vm._v(_vm._s(option.text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }